module.exports = __webpack_public_path__ + "static/media/20150630_472842_529425.172fa0e0.mp3";